export default "__VITE_ASSET__fb8f64a3__"